import { RoundCommandError } from "../round/round-errors.js";
import type { RoundCommandPayload } from "../round/round-commands.js";
import { isRoundV3, type RoundSnapshot } from "../round/round-types.js";
import { freezeFinishedMatches, replaceContest } from "./contest-state.js";
import { selectContests } from "./contest-selectors.js";

export function setHoleBonus(
  snapshot: RoundSnapshot,
  payload: RoundCommandPayload,
): RoundSnapshot {
  if (
    !isRoundV3(snapshot) ||
    snapshot.state !== "active" ||
    snapshot.importedTotals
  )
    throw new RoundCommandError(
      "Hole bonuses can only change before Finish Round.",
    );
  if (
    !("enabled" in payload) ||
    !("winnerId" in payload) ||
    !["longest-drive", "closest-to-pin"].includes(payload.kind) ||
    !snapshot.orderedHoleNumbers.includes(payload.holeNumber) ||
    (payload.winnerId !== null &&
      !snapshot.participants.some((p) => p.id === payload.winnerId))
  )
    throw new RoundCommandError("Choose a hole and a player in this round.");
  const bonuses = (snapshot.holeBonuses ?? []).filter(
    (b) => b.holeNumber !== payload.holeNumber || b.kind !== payload.kind,
  );
  if (payload.enabled)
    bonuses.push({
      holeNumber: payload.holeNumber,
      kind: payload.kind,
      winnerId: payload.winnerId,
    });
  let next = {
    ...snapshot,
    holeBonuses: bonuses,
    version: snapshot.version + 1,
  };
  const contest = selectContests(snapshot).findLast((c) =>
    c.holeNumbers.includes(payload.holeNumber),
  );
  if (contest)
    next = {
      ...replaceContest(next, {
        ...contest,
        result: null,
        qualification: undefined,
        adjudication: undefined,
        dependencyReason: undefined,
      }),
      holeBonuses: bonuses,
    };
  return freezeFinishedMatches(next);
}
